// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ni0i","controls":"styles_controls__1CFB7","charLimit":"styles_charLimit__2vUw9","input":"styles_input__2eiht","send":"styles_send__1hTe1"};